import React from "react";
import { Form, Button } from "react-bootstrap";

export default function SignIn({ signIn, form, onChange, isLoading }) {
  return (
    <div className="glass-panel floating-card signin-card">
      <div className="signin-head">
        <div>
          <p className="text-uppercase text-primary fw-semibold mb-1" style={{ letterSpacing: ".08em" }}>
            Доступ в кабинет
          </p>
          <h4 className="fw-bold m-0">К управлению едой</h4>
        </div>
      </div>

      <Form onSubmit={signIn} className="signin-form">
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label>Логин</Form.Label>
          <div className="input-wrap">
            <i className="bi bi-person" />
            <Form.Control
              type="text"
              placeholder="login@team"
              value={form.login}
              onChange={onChange}
              name="login"
              autoComplete="username"
            />
          </div>
        </Form.Group>

        <Form.Group className="mb-4" controlId="formBasicPassword">
          <Form.Label>Пароль</Form.Label>
          <div className="input-wrap">
            <i className="bi bi-shield-lock" />
            <Form.Control
              type="password"
              placeholder="Введите пароль"
              value={form.password}
              onChange={onChange}
              name="password"
              autoComplete="current-password"
            />
          </div>
        </Form.Group>

        <Button variant="primary" type="submit" disabled={isLoading} className="w-100 py-3">
          {isLoading ? "Загрузка..." : "Войти"}
        </Button>
      </Form>
    </div>
  );
}
